import axios from 'axios';

export const CustomAnswerApi = {
    listInspectionCustomAnswer: (inspectionQuestionId) => axios.get(`/web/inspection-custom-answer/${inspectionQuestionId}`),
    updateInspectionCustomAnswer: (inspectionQuestionId, inspectionCustomAnswers) => axios.put(`/web/inspection-custom-answer/${inspectionQuestionId}`, inspectionCustomAnswers),
}
